var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.67333e-05H11.82C14 0 10.3 8.53027e-05 9 8.53027e-05C7.7 8.53027e-05 4.09 8.67333e-05 6.18 8.67333e-05H2C0.9 8.67333e-05 0 0.900087 0 2.00009V16.0001C0 17.1001 0.9 18.0001 2 18.0001H16C17.1 18.0001 18 17.1001 18 16.0001V2.00009C18 0.900087 17.1 8.67333e-05 16 8.67333e-05ZM13 12.0001H9V15.0001L4 10.0001L9 5.00009V8.00009H13V12.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.cc5b4b8b99288a777b88c08a9a83a558.svg";
export { ForwardRef as ReactComponent };